import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { FRONT, PROGRAM_MOVIES_ITEMS, SITEHEADERDATA, THEME, TRANSLATION, UI_TRAILER } from '../../constants/state'
import OverviewFilter from './OverviewFilter'
import getData from '../../functions/getData'
import toJS from '../../hoc/toJS'

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT), 
    translation: getData(state, TRANSLATION),
    siteHeaderData: getData(state, SITEHEADERDATA),
    theme: getData(state, THEME),
    movies: getData(state, PROGRAM_MOVIES_ITEMS),
    hasYoutubeCookieConfirmation: getData(state, [UI_TRAILER, 'hasYoutubeCookieConfirmation'])
})

const OverviewFilterContainer = ({
    theme, 
    translation, 
    siteHeaderData,
    movies,
    cinemaDataFront,
    dayFilters,
    filterDisplay,
    dayFilterDisplay,
    allItems,
    cinemaFrontPkType,
    filters,
    activeView,
    searchFilter,
    activeFilters,
    queryStringValues,
    openFilter,
    onChangeOverviewView,
    toggleFilter,
    toggleDayFilter,
    openDayFilter,
    hasYoutubeCookieConfirmation
}) => {

    const {
        has_showtimes_feature,
        information_style,
        has_grid_trailer_feature
    } = cinemaDataFront

    const {theme_colors} = theme

    return (
        <OverviewFilter
            siteHeaderData={siteHeaderData}
            filterDisplay={filterDisplay}
            dayFilterDisplay={dayFilterDisplay}
            informationStyling={information_style}
            allItems={allItems}
            cinemaFrontPkType={cinemaFrontPkType}
            movies={movies}
            theme={theme_colors}
            filters={filters}
            dayFilters={dayFilters}
            activeView={activeView}
            searchFilter={searchFilter}
            activeFilters={activeFilters}
            queryStringValues={queryStringValues}
            openFilter={openFilter}
            onChangeOverviewView={onChangeOverviewView}
            toggleFilter={toggleFilter}
            toggleDayFilter={toggleDayFilter}
            openDayFilter={openDayFilter}
            translation={translation}
            hasShowtimesFeature={has_showtimes_feature}
            hasGridTrailerFeature={has_grid_trailer_feature && true === hasYoutubeCookieConfirmation}
        />
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(OverviewFilterContainer)